/**
 * User: daletan
 * Date: 3/12/16
 * Time: 8:57 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const styles = require('./_spinner.scss');

/**
 * @param {object} props
 * @param {string} [props.additionalOverlayClasses]
 * @param {string} [props.additionalSpinnerClasses]
 * @param {string} [props.position="isFixed"] Accepts `isAbsolute`, `isStatic`, defaults to `isFixed`
 * @returns
 * @constructor
 */
const Overlay = (props = {}) => {
    const {
        additionalWrapperClasses,
        additionalOverlayClasses,
        additionalSpinnerClasses,
        position = 'isFixed',
    } = props;
    const wrapperClasses = classNames({
        'overlay-spinner-wrapper': true,
        [additionalWrapperClasses]: !!additionalWrapperClasses,
    });
    const overlayClasses = classNames({
        [styles.spinnerWrapper]: styles.spinnerWrapper,
        'ajax-overlay': true,
        [additionalOverlayClasses]: !!additionalOverlayClasses,
    });
    const spinnerClasses = classNames({
        [styles.spinner]: styles.spinner,
        // used for testing
        'tn-overlaySpinner': true,
        [additionalSpinnerClasses]: !!additionalSpinnerClasses,
        [styles[position]]: !!position,
    });
    return (
        <div className={wrapperClasses}>
            <div className={overlayClasses} />
            <div className={spinnerClasses} data-tn="loading-check" />
        </div>
    );
};

Overlay.propTypes = {
    additionalWrapperClasses: PropTypes.string,
    additionalOverlayClasses: PropTypes.string,
    additionalSpinnerClasses: PropTypes.string,
    position: PropTypes.string,
};

module.exports = Overlay;



// WEBPACK FOOTER //
// ./assets/js/components/OverlaySpinner/OverlaySpinner.jsx